import {Box, Tab, TabList, TabPanels, Tabs, Text} from '@chakra-ui/react';
import Card from 'components/Card/Card';
import {SingleEliminationPlayoffBracket} from 'components/PlayoffBracket/SingleEliminationPlayoffBracket';
import {DoubleEliminationPlayoffBracket} from 'components/PlayoffBracket/DoubleEliminationPlayoffBracket';
import {Round, Team} from 'types/dto';

interface League {
  id: number;
  name: string;
}

interface PlayoffBracketDisplayProps {
  leagues?: League[];
  teams?: Team[];
  schedule: Round[];
  isDoubleElimination: boolean;
  selectedLeague?: number;
  onLeagueChange: (leagueId: number) => void;
}

export const PlayoffBracketDisplay: React.FC<PlayoffBracketDisplayProps> = ({
                                                                              leagues,
                                                                              teams,
                                                                              schedule,
                                                                              isDoubleElimination,
                                                                              selectedLeague,
                                                                              onLeagueChange,
                                                                            }) => {
  const selectedIndex = leagues?.findIndex((l) => l.id === selectedLeague) ?? 0;

  return (
    <Card w="100%" h="100%" maxH="750px" overflow="auto">
      <Tabs
        index={selectedIndex}
        onChange={(idx) => {
          if (leagues) {
            onLeagueChange(leagues[idx].id);
          }
        }}
        isFitted
        colorScheme="blue"
      >
        <TabList>
          {leagues?.map((league) => (
            <Tab key={league.id}>{league.name}</Tab>
          ))}
        </TabList>
        <TabPanels>
          <Box overflowX="scroll" p={4}>
            {schedule && schedule.length > 0 ? (
              isDoubleElimination ? (
                <DoubleEliminationPlayoffBracket
                  schedule={schedule}
                  teams={teams || []}
                />
              ) : (
                <SingleEliminationPlayoffBracket
                  schedule={schedule}
                  teams={teams || []}
                />
              )
            ) : (
              <Box textAlign="center" py={8}>
                <Text color="gray.500">
                  No playoff schedule available for this league
                </Text>
              </Box>
            )}
          </Box>
        </TabPanels>
      </Tabs>
    </Card>
  );
};
